module.exports = __webpack_public_path__ + "static/media/branch-cake.01ba6245.jpg";